import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-add-insider-comment',
  // imports: [],
  templateUrl: './add-insider-comment.component.html',
  styleUrl: './add-insider-comment.component.css',
  standalone: false,
})
export class AddInsiderCommentComponent {
  comment: string = '';
  parentComment: string = '';
  parentName: string = '';
  childComment: string = '';
  childName: string = '';
  hasParent: boolean = false;
  hasChild: boolean = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.comment = this.config.data?.insiderComment || '';
    this.parentComment = this.config.data?.parentComment || '';
    this.parentName = this.config.data?.parentName || '';
    this.hasParent = !!this.config.data?.hasParent;

    
    if (this.config.data?.childComments && Array.isArray(this.config.data.childComments)) {
      const childArray = this.config.data.childComments as any[];
      if (childArray.length > 0) {
        const firstChild = childArray[0];
        this.childName = firstChild?.insiderName || firstChild?.name || 'Child Insider';
        this.childComment =
          firstChild?.insiderComment || firstChild?.comment || '';
        this.hasChild = true;
      }
    } else if (this.config.data?.childComment) {
      
      this.childName = this.config.data.childName || 'Child Insider';
      this.childComment = this.config.data.childComment || '';
      this.hasChild = true;
    }
  }

  onSave() {
    // Prepare children array with comments for all selected children
    const children: Array<{ insiderId: number; insiderComment?: string }> = [];
    
    if (this.hasChild && this.config.data?.selectedChildRows) {
      // Apply the edited child comment to all selected children
      this.config.data.selectedChildRows.forEach((child: any) => {
        children.push({
          insiderId: child.insiderId,
          insiderComment: this.childComment.trim() || undefined
        });
      });
    }

    // Call onMapClick callback if provided, passing parent comment and children array
    if (this.config.data && this.config.data.onMapClick) {
      this.config.data.onMapClick({
        parentComment: this.parentComment.trim() || undefined,
        children: children.length > 0 ? children : undefined
      });
    }
    // Close the dialog
    this.ref.close();
  }

  onCancel() {
    this.ref.close();
  }
}
